import { useEffect, useState } from "react";
import { api, setToken, getToken, clearToken } from "rsa/api";
import { useSocket } from "rsa/useSocket";
import "rsa/rsa.scss";
import "./admin.scss";

export default function AdminRsa() {
  const [token, setTok] = useState(getToken("admin"));
  const [email, setEmail] = useState("raees@gmail.com");
  const [password, setPassword] = useState("raees@123");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const [types, setTypes] = useState([]);
  const [requests, setRequests] = useState([]);
  const [seedMsg, setSeedMsg] = useState("");

  const login = async () => {
    setBusy(true); setErr("");
    try {
      const r = await api("POST", "/auth/login", { body: { email, password } });
      if (r.user.role !== "admin" && r.user.role !== "super_admin") throw new Error("Not an admin account.");
      setToken("admin", r.token); setTok(r.token);
    } catch (e) { setErr(e.message); } finally { setBusy(false); }
  };
  const logout = () => { clearToken("admin"); setTok(null); };

  const load = async () => {
    if (!token) return;
    try {
      setTypes(await api("GET", "/rsa/service-types"));
      setRequests(await api("GET", "/admin/rsa/requests", { token }));
    } catch (e) { if (e.status === 401) logout(); }
  };
  useEffect(() => { load(); }, [token]); // eslint-disable-line

  useSocket(token, {
    "request:new": load, "request:claimed": load, "request:status": load,
  });

  const seedHere = () => {
    setSeedMsg("Locating…");
    const done = async (lat, lng) => {
      try {
        const r = await api("POST", "/admin/demo/seed-vendors", { token, body: { lat, lng, count: 6, radiusKm: 8 } });
        setSeedMsg(`✅ ${r.seeded} vendors placed & set online around you: ${r.vendors.join(", ")}`);
        load();
      } catch (e) { setSeedMsg("Error: " + e.message); }
    };
    if (!navigator.geolocation) return done(19.076, 72.8777);
    navigator.geolocation.getCurrentPosition(
      (p) => done(p.coords.latitude, p.coords.longitude),
      () => done(19.076, 72.8777), { enableHighAccuracy: true, timeout: 8000 });
  };

  const saveFee = async (t, field, value) => {
    const body = field === "base" ? { baseFee: +value } : { perKmFee: +value };
    const updated = await api("PATCH", `/admin/rsa/service-types/${t.id}`, { token, body });
    setTypes((prev) => prev.map((x) => (x.id === t.id ? updated : x)));
  };

  if (!token)
    return (
      <div className="avah-rsa admin">
        <div className="avah-rsa__top" style={{ background: "linear-gradient(135deg,#1e3a8a,#172554)" }}>
          <h1>🛡️ Avahan RSA Admin</h1><p>Emergency operations console</p>
        </div>
        <div className="avah-rsa__shell">
          <div className="avah-rsa__card">
            <label className="avah-rsa__label">Email</label>
            <input className="avah-rsa__input" value={email} onChange={(e) => setEmail(e.target.value)} />
            <label className="avah-rsa__label" style={{ marginTop: 12 }}>Password</label>
            <input className="avah-rsa__input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
            <button className="avah-rsa__btn avah-rsa__btn--primary" style={{ marginTop: 16, background: "#1e3a8a" }}
              disabled={busy} onClick={login}>{busy ? "Signing in…" : "Sign in"}</button>
            {err && <div className="avah-rsa__err">{err}</div>}
            <p style={{ fontSize: 12, color: "#6b7280", marginBottom: 0 }}>Demo: raees@gmail.com / raees@123</p>
          </div>
        </div>
      </div>
    );

  return (
    <div className="avah-rsa admin">
      <div className="admin__bar">
        <b>🛡️ RSA Operations</b>
        <button className="avah-rsa__btn avah-rsa__btn--ghost" style={{ width: "auto", padding: "8px 12px" }} onClick={logout}>Exit</button>
      </div>
      <div className="admin__grid">
        <div className="avah-rsa__card">
          <h3 style={{ marginTop: 0 }}>Demo setup</h3>
          <p style={{ fontSize: 13, color: "#6b7280" }}>
            Place partner vendors around your current location and set them online, so nearby search works wherever you present.
          </p>
          <button className="avah-rsa__btn avah-rsa__btn--primary" onClick={seedHere}>📍 Seed vendors near me</button>
          {seedMsg && <div className="avah-rsa__dev" style={{ marginTop: 10 }}>{seedMsg}</div>}
        </div>

        <div className="avah-rsa__card">
          <h3 style={{ marginTop: 0 }}>Fee model</h3>
          <table className="admin__table">
            <thead><tr><th>Service</th><th>Base ₹</th><th>₹/km</th></tr></thead>
            <tbody>
              {types.map((t) => (
                <tr key={t.id}>
                  <td>{t.name}</td>
                  <td><input defaultValue={Math.round(t.base_fee)} onBlur={(e) => saveFee(t, "base", e.target.value)} /></td>
                  <td><input defaultValue={Math.round(t.per_km_fee)} onBlur={(e) => saveFee(t, "perkm", e.target.value)} /></td>
                </tr>
              ))}
            </tbody>
          </table>
          <p style={{ fontSize: 11, color: "#6b7280" }}>Edit and click away to save.</p>
        </div>

        <div className="avah-rsa__card admin__wide">
          <div className="avah-rsa__row" style={{ justifyContent: "space-between" }}>
            <h3 style={{ margin: 0 }}>Live requests</h3>
            <span className="avah-rsa__pill avah-rsa__pill--live">● live</span>
          </div>
          <table className="admin__table" style={{ marginTop: 10 }}>
            <thead><tr><th>Ref</th><th>Type</th><th>Requester</th><th>Sev</th><th>Status</th><th>Vendor</th><th>Fee</th></tr></thead>
            <tbody>
              {requests.length === 0 && <tr><td colSpan={7} style={{ color: "#6b7280", textAlign: "center" }}>No requests yet</td></tr>}
              {requests.map((r) => (
                <tr key={r.id}>
                  <td>{r.request_ref}</td>
                  <td>{r.service_type}</td>
                  <td>{r.requester_name} <span className="admin__tag">{r.requester_type}</span></td>
                  <td className={r.severity === "critical" ? "admin__crit" : ""}>{r.severity}</td>
                  <td><span className={`admin__status admin__status--${r.status}`}>{r.status}</span></td>
                  <td>{r.vendor_name || "—"}</td>
                  <td>{r.final_fee ? `₹${Math.round(r.final_fee)}` : r.estimated_fee ? `~₹${Math.round(r.estimated_fee)}` : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
